"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const headerLogoDarkSelector = ".header .header__logo .dark";
const headerLogoLightSelector = ".header .header__logo .light";
const sectionImageSelector = ".image-hero .image__img, " + // image hero
    ".slideshow .slideshow-slide:first-child .slideshow-slide__image-container .image__inner .image__img, " + // slideshow
    ".video-hero .video-hero__media-container .image__img, " + // video hero (background image only)
    ".video-hero .video-hero__media-container .video-hero__video"; // video hero (video element)
const defaultRGB = { r: 0, g: 0, b: 0, a: 0 }; // for non-supporting envs
function onLoad() {
    return __awaiter(this, void 0, void 0, function* () {
        showLogo('light'); // dark logo by default
        const element = getTopSectionVisibleElement();
        let backgroundColorType = 'light'; // by default show dark logo
        if (element) {
            if (element instanceof HTMLImageElement) {
                const avgColor = yield getAverageImageColor(element);
                backgroundColorType = getColorType(avgColor);
            }
            else if (element instanceof HTMLVideoElement) {
                const rgbColor = yield getVideoFirstFrameColor(element);
                if (rgbColor) {
                    backgroundColorType = getColorType(rgbColor);
                }
            }
            else {
                const rgbColor = parseRgbColor(window.getComputedStyle(element, null).backgroundColor);
                if (rgbColor) {
                    backgroundColorType = getColorType(rgbColor);
                }
            }
        }
        showLogo(backgroundColorType);
    });
}
function getVideoFirstFrameColor(element) {
    return __awaiter(this, void 0, void 0, function* () {
        const image = yield loadFirstFrameVideoImage(element);
        return yield getAverageImageColor(image);
    });
}
function getAverageImageColor(element) {
    return __awaiter(this, void 0, void 0, function* () {
        const image = yield loadImage(element.src);
        const blockSize = 5, // only visit every 5 pixels
        canvas = document.createElement('canvas'), context = canvas.getContext && canvas.getContext('2d'), rgb = { r: 0, g: 0, b: 0, a: 0 };
        let data, width = 0, height = 0, i = -4, length = 0, count = 0;
        if (!context) {
            return defaultRGB;
        }
        height = canvas.height = image.naturalHeight || image.offsetHeight || image.height;
        width = canvas.width = image.naturalWidth || image.offsetWidth || image.width;
        context.drawImage(image, 0, 0);
        try {
            data = context.getImageData(0, 0, width, height);
        }
        catch (e) {
            /* security error, img on diff domain */
            return defaultRGB;
        }
        length = data.data.length;
        while ((i += blockSize * 4) < length) {
            ++count;
            rgb.r += data.data[i];
            rgb.g += data.data[i + 1];
            rgb.b += data.data[i + 2];
        }
        // ~~ used to floor values
        rgb.r = ~~(rgb.r / count);
        rgb.g = ~~(rgb.g / count);
        rgb.b = ~~(rgb.b / count);
        return rgb;
    });
}
function loadImage(src) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((res) => {
            const image = new Image();
            image.crossOrigin = "Anonymous";
            image.addEventListener('load', function () {
                res(image);
            }, false);
            image.src = src;
        });
    });
}
function loadFirstFrameVideoImage(video) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((res) => {
            video.onloadeddata = () => {
                const canvas = document.createElement('canvas');
                canvas.height = video.videoHeight;
                canvas.width = video.videoWidth;
                const ctx = canvas.getContext('2d');
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                }
                const img = new Image();
                img.src = canvas.toDataURL();
                res(img);
            };
        });
    });
}
function showLogo(backgroundColorType) {
    const lightLogo = getVisibleLogoElement(headerLogoLightSelector);
    const darkLogo = getVisibleLogoElement(headerLogoDarkSelector);
    if (backgroundColorType === 'light') {
        if (darkLogo) {
            addLogoVisibleClass(darkLogo);
            removeLogoVisibleClass(lightLogo);
        }
        else {
            addLogoVisibleClass(lightLogo);
        }
    }
    else {
        if (lightLogo) {
            addLogoVisibleClass(lightLogo);
            removeLogoVisibleClass(darkLogo);
        }
        else {
            addLogoVisibleClass(darkLogo);
        }
    }
}
function getVisibleLogoElement(logoSelector) {
    const logoElements = document.querySelectorAll(logoSelector);
    if (logoElements) {
        for (const logoElement of logoElements) {
            if (isElementVisible(logoElement)) {
                return logoElement;
            }
            let parent = logoElement.parentElement;
            while (parent != null) {
                if (parent.classList.contains('header__row')) {
                    break;
                }
                parent = parent.parentElement;
            }
            if (isElementVisible(parent)) {
                return logoElement;
            }
        }
    }
    return undefined;
}
function removeLogoVisibleClass(logo) {
    if (logo && logo.classList.contains('logo-visible')) {
        logo.classList.remove('logo-visible');
    }
}
function addLogoVisibleClass(logo) {
    if (logo && !logo.classList.contains('logo-visible')) {
        logo.classList.add('logo-visible');
    }
}
function getTopSectionVisibleElement() {
    const sections = document.querySelectorAll('main > section');
    // find first visible
    for (const section of sections) {
        if (!isElementVisible(section)) {
            continue;
        }
        if (section) {
            const elements = section.querySelectorAll(sectionImageSelector);
            if (elements) {
                for (const element of elements) {
                    if (element instanceof HTMLElement && isElementVisible(element)) {
                        return element;
                    }
                }
            }
        }
    }
    return undefined;
}
/** Function check if element is visible, also check any of its parent element. */
function isElementVisible(el) {
    return !!el.offsetParent;
}
function parseRgbColor(rgb) {
    const array = rgb.substring(4, rgb.length - 1)
        .replace(/ /g, '')
        .split(',');
    if (!array || array.length < 3) {
        return undefined;
    }
    return {
        r: Number(array[0]),
        g: Number(array[1]),
        b: Number(array[2]),
        a: 0
    };
}
function getColorType(color) {
    // HSP equation from http://alienryderflex.com/hsp.html
    const hsp = Math.sqrt(0.299 * (color.r * color.r) +
        0.587 * (color.g * color.g) +
        0.114 * (color.b * color.b));
    // Using the HSP value, determine whether the color is light or dark
    return hsp > 127.5 ? 'light' : 'dark';
}
document.addEventListener('DOMContentLoaded', onLoad);
